const RECAPTCHA_SITE_KEY = '6LfstEItAAAAAEgggmhXs0q7T7SiSFSTqImoBYz7';

/**
 * Execute reCAPTCHA v3 and return a token.
 * @param {string} action - The action name (e.g., 'contact', 'consultation')
 * @returns {Promise<string>} The reCAPTCHA token
 */
export const getRecaptchaToken = (action = 'submit') => {
  return new Promise((resolve) => {
    if (!window.grecaptcha) {
      resolve('');
      return;
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(RECAPTCHA_SITE_KEY, { action })
        .then(resolve)
        .catch(() => resolve(''));
    });
  });
};
